import {atom} from 'recoil'

export const DossierIdState = atom({
    key : 'dossieridState',
    default:'60037692bcda2a0024c837a8'
})
